import * as Types from '../../../../../../../admin/graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchUserQueryVariables = Types.Exact<{
  filters: Types.UsersV2Filters;
  pagination?: Types.InputMaybe<Types.UsersConnectionArgs>;
}>;


export type FetchUserQuery = { __typename?: 'Query', usersv2: { __typename?: 'UsersIUserConnection', edges: Array<{ __typename?: 'UsersIUserEdge', node: { __typename?: 'Admin', firstName?: string | null, lastName?: string | null, id?: number | null } | { __typename?: 'Customer', firstName?: string | null, lastName?: string | null, id?: number | null } | { __typename?: 'Mechanic', firstName?: string | null, lastName?: string | null, id?: number | null } }>, pageInfo: { __typename?: 'UsersPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export const FetchUserDocument = gql`
    query FetchUser($filters: UsersV2Filters!, $pagination: UsersConnectionArgs) {
  usersv2(filters: $filters, pagination: $pagination) {
    edges {
      node {
        id: userId
        firstName
        lastName
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchUserGQL extends Apollo.Query<FetchUserQuery, FetchUserQueryVariables> {
    override document = FetchUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }